(function(){
  'use strict';
  if(window.__KDK_BESTSELLER_SCROLL_2026__)return;
  window.__KDK_BESTSELLER_SCROLL_2026__=true;
  function init(root){
    if(!root||root.dataset.kdkBestReady==='true')return;
    var rail=root.querySelector('[data-kdk-bestsellers-rail]');
    var previous=root.querySelector('[data-kdk-bestsellers-prev]');
    var next=root.querySelector('[data-kdk-bestsellers-next]');
    var navigation=root.querySelector('[data-kdk-bestsellers-nav]');
    if(!rail||!previous||!next||!navigation)return;
    var addedMen=Array.from(rail.querySelectorAll('[data-kdk-men-extra]'));
    var originalCards=Array.from(rail.querySelectorAll('.kdk-luxe-products__item:not([data-kdk-men-extra])'));
    addedMen.forEach(function(card,index){
      var anchor=originalCards[3+index*2];
      if(anchor)rail.insertBefore(card,anchor);
    });
    root.dataset.kdkBestReady='true';
    var progress=navigation.querySelector('[data-kdk-bestsellers-progress]');
    function shown(){
      return Array.from(rail.querySelectorAll('.kdk-luxe-products__item')).filter(function(item){return !item.hidden;});
    }
    function sync(){
      var max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      previous.disabled=rail.scrollLeft<4;
      next.disabled=max<4||rail.scrollLeft>=max-4;
      navigation.hidden=shown().length<2||max<4;
      if(progress)progress.style.width=String(24+76*(max?rail.scrollLeft/max:0))+'%';
      root.querySelectorAll('[data-kdk-home-filter]').forEach(function(button){
        if(button.getAttribute('data-kdk-home-filter')==='all')return;
        button.hidden=!Array.from(rail.querySelectorAll('[data-kdk-home-group]')).some(function(card){
          return card.getAttribute('data-kdk-home-group')===button.getAttribute('data-kdk-home-filter');
        });
      });
    }
    function move(direction){
      var card=shown()[0];
      if(!card)return;
      var gap=parseFloat(window.getComputedStyle(rail).columnGap)||16;
      var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:reduce?'auto':'smooth'});
    }
    previous.addEventListener('click',function(){move(-1);});
    next.addEventListener('click',function(){move(1);});
    rail.addEventListener('keydown',function(event){
      if(event.target!==rail)return;
      if(event.key==='ArrowRight'){event.preventDefault();move(1);}
      if(event.key==='ArrowLeft'){event.preventDefault();move(-1);}
    });
    rail.addEventListener('scroll',sync,{passive:true});
    if(window.ResizeObserver)new ResizeObserver(sync).observe(rail);
    else window.addEventListener('resize',sync,{passive:true});
    root.addEventListener('click',function(event){
      if(event.target.closest('[data-kdk-home-filter]')){
        window.requestAnimationFrame(function(){rail.scrollLeft=0;sync();});
      }
    });
    sync();
  }
  function ready(){document.querySelectorAll('[data-kdk-bestsellers]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);
  else ready();
  document.addEventListener('shopify:section:load',ready);
})();